// This file is auto-generated by @hey-api/openapi-ts

import { type Options as ClientOptions, type TDataShape, type Client, formDataBodySerializer } from './client';
import type { GetAntiForgeryTokenData, GetAntiForgeryTokenResponses, GetCustomerListData, GetCustomerListResponses, GetCustomerListErrors, CreateCustomerData, CreateCustomerResponses, CreateCustomerErrors, DeleteCustomerData, DeleteCustomerResponses, DeleteCustomerErrors, GetCustomerData, GetCustomerResponses, GetCustomerErrors, UpdateCustomerData, UpdateCustomerResponses, UpdateCustomerErrors, DownloadDataImportFileData, DownloadDataImportFileErrors, UploadDataImportFileData, UploadDataImportFileResponses, UploadDataImportFileErrors, GetImportReportData, GetImportReportResponses, GetImportReportErrors, GetImportReportChangesData, GetImportReportChangesResponses, GetImportReportChangesErrors, GetImportReportSheetRowsData, GetImportReportSheetRowsResponses, GetImportReportSheetRowsErrors, GetImportRequestStatusData, GetImportRequestStatusResponses, GetImportRequestStatusErrors, ConfirmImportRequestData, ConfirmImportRequestResponses, ConfirmImportRequestErrors, GetImportRequestStatusListData, GetImportRequestStatusListResponses, DeleteImportRequestData, DeleteImportRequestResponses, DeleteImportRequestErrors, GetResidenceCategoryListData, GetResidenceCategoryListResponses, GetResidenceCategoryListErrors, CreateResidenceCategoryData, CreateResidenceCategoryResponses, CreateResidenceCategoryErrors, DeleteResidenceCategoryData, DeleteResidenceCategoryResponses, DeleteResidenceCategoryErrors, GetResidenceCategoryData, GetResidenceCategoryResponses, GetResidenceCategoryErrors, UpdateResidenceCategoryData, UpdateResidenceCategoryResponses, UpdateResidenceCategoryErrors, GetResidenceTypeListData, GetResidenceTypeListResponses, GetResidenceTypeListErrors, CreateResidenceTypeData, CreateResidenceTypeResponses, CreateResidenceTypeErrors, DeleteResidenceTypeData, DeleteResidenceTypeResponses, DeleteResidenceTypeErrors, GetResidenceTypeData, GetResidenceTypeResponses, GetResidenceTypeErrors, UpdateResidenceTypeData, UpdateResidenceTypeResponses, UpdateResidenceTypeErrors, GetUnpublishedResidenceTypeWithNoImageListData, GetUnpublishedResidenceTypeWithNoImageListResponses, GetUnpublishedResidenceTypeWithNoImageListErrors, GetResidenceTypeImageData, GetResidenceTypeImageResponses, GetResidenceTypeImageErrors, UploadImageForResidenceTypeData, UploadImageForResidenceTypeResponses, UploadImageForResidenceTypeErrors, GetAssignedCustomerListFromResidenceTypeData, GetAssignedCustomerListFromResidenceTypeResponses, GetAssignedCustomerListFromResidenceTypeErrors, AssignCustomerToResidenceTypeData, AssignCustomerToResidenceTypeResponses, AssignCustomerToResidenceTypeErrors, UnassignCustomerFromResidenceTypeData, UnassignCustomerFromResidenceTypeResponses, UnassignCustomerFromResidenceTypeErrors, PublishResidenceTypeData, PublishResidenceTypeResponses, PublishResidenceTypeErrors, UnpublishResidenceTypeData, UnpublishResidenceTypeResponses, UnpublishResidenceTypeErrors, ArchiveResidenceTypeData, ArchiveResidenceTypeResponses, ArchiveResidenceTypeErrors, GetRoofTypeListData, GetRoofTypeListResponses, GetRoofTypeListErrors, CreateRoofTypeData, CreateRoofTypeResponses, CreateRoofTypeErrors, DeleteRoofTypeData, DeleteRoofTypeResponses, DeleteRoofTypeErrors, GetRoofTypeData, GetRoofTypeResponses, GetRoofTypeErrors, UpdateRoofTypeData, UpdateRoofTypeResponses, UpdateRoofTypeErrors, GetScenarioListData, GetScenarioListResponses, GetScenarioListErrors, GetScenarioData, GetScenarioResponses, GetScenarioErrors, PublishScenarioData, PublishScenarioResponses, PublishScenarioErrors, UnpublishScenarioData, UnpublishScenarioResponses, UnpublishScenarioErrors, GetSituationListData, GetSituationListResponses, GetSituationListErrors, GetSituationData, GetSituationResponses, GetSituationErrors, PublishSituationData, PublishSituationResponses, PublishSituationErrors, UnpublishSituationData, UnpublishSituationResponses, UnpublishSituationErrors } from './types.gen';
import { client as _heyApiClient } from './client.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean> = ClientOptions<TData, ThrowOnError> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: Record<string, unknown>;
};

/**
 * Retrieve anti forgery token
 * Get and store an anti forgery token for the current session.
 */
export const getAntiForgeryToken = <ThrowOnError extends boolean = false>(options?: Options<GetAntiForgeryTokenData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetAntiForgeryTokenResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/anti-forgery/token',
        ...options
    });
};

/**
 * Get customers
 * Gets a list of customers.
 */
export const getCustomerList = <ThrowOnError extends boolean = false>(options: Options<GetCustomerListData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetCustomerListResponses, GetCustomerListErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/customers',
        ...options
    });
};

/**
 * Create customer
 * Creates a new customer.
 */
export const createCustomer = <ThrowOnError extends boolean = false>(options: Options<CreateCustomerData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CreateCustomerResponses, CreateCustomerErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/customers',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Delete customer
 * Deletes a customer.
 */
export const deleteCustomer = <ThrowOnError extends boolean = false>(options: Options<DeleteCustomerData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<DeleteCustomerResponses, DeleteCustomerErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/customers/{customerId}',
        ...options
    });
};

/**
 * Get customer
 * Gets a specific customer.
 */
export const getCustomer = <ThrowOnError extends boolean = false>(options: Options<GetCustomerData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetCustomerResponses, GetCustomerErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/customers/{customerId}',
        ...options
    });
};

/**
 * Update customer
 * Updates a customer.
 */
export const updateCustomer = <ThrowOnError extends boolean = false>(options: Options<UpdateCustomerData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<UpdateCustomerResponses, UpdateCustomerErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/customers/{customerId}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Download data import file
 * Downloads a data import file.
 */
export const downloadDataImportFile = <ThrowOnError extends boolean = false>(options: Options<DownloadDataImportFileData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<unknown, DownloadDataImportFileErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/data-import-files/{fileReferenceId}',
        ...options
    });
};

/**
 * Upload data import file
 * Adds a data import file to the import queue.
 */
export const uploadDataImportFile = <ThrowOnError extends boolean = false>(options?: Options<UploadDataImportFileData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<UploadDataImportFileResponses, UploadDataImportFileErrors, ThrowOnError>({
        ...formDataBodySerializer,
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/data-import-files',
        ...options,
        headers: {
            'Content-Type': null,
            ...options?.headers
        }
    });
};

/**
 * Get import report
 * Gets an import report.
 */
export const getImportReport = <ThrowOnError extends boolean = false>(options: Options<GetImportReportData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetImportReportResponses, GetImportReportErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/import-reports/{id}',
        ...options
    });
};

/**
 * Get import report changes
 * Gets a list of import report changes.
 */
export const getImportReportChanges = <ThrowOnError extends boolean = false>(options: Options<GetImportReportChangesData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetImportReportChangesResponses, GetImportReportChangesErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/import-reports/{importReportId}/changes',
        ...options
    });
};

/**
 * Get import report sheet rows
 * Gets a list of import report sheet rows.
 */
export const getImportReportSheetRows = <ThrowOnError extends boolean = false>(options: Options<GetImportReportSheetRowsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetImportReportSheetRowsResponses, GetImportReportSheetRowsErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/import-reports/sheets/{importReportSheetId}/rows',
        ...options
    });
};

/**
 * Get import request status
 * Gets the status of the import request.
 */
export const getImportRequestStatus = <ThrowOnError extends boolean = false>(options: Options<GetImportRequestStatusData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetImportRequestStatusResponses, GetImportRequestStatusErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/import-requests/{id}',
        ...options
    });
};

/**
 * Confirm import request
 * Confirms a previously completed dry-run and starts a full-run for importing the data import file.
 */
export const confirmImportRequest = <ThrowOnError extends boolean = false>(options: Options<ConfirmImportRequestData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ConfirmImportRequestResponses, ConfirmImportRequestErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/import-requests/{id}',
        ...options
    });
};

/**
 * Get import request status
 * Gets the status of the import request.
 */
export const getImportRequestStatusList = <ThrowOnError extends boolean = false>(options: Options<GetImportRequestStatusListData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetImportRequestStatusListResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/import-requests',
        ...options
    });
};

/**
 * Delete import request
 * Deletes an import request.
 */
export const deleteImportRequest = <ThrowOnError extends boolean = false>(options: Options<DeleteImportRequestData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<DeleteImportRequestResponses, DeleteImportRequestErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/import-requests/{importRequestId}',
        ...options
    });
};

/**
 * Get residence categories
 * Gets a list of residence categories.
 */
export const getResidenceCategoryList = <ThrowOnError extends boolean = false>(options: Options<GetResidenceCategoryListData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetResidenceCategoryListResponses, GetResidenceCategoryListErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/residence-categories',
        ...options
    });
};

/**
 * Create residence category
 * Creates a new residence category.
 */
export const createResidenceCategory = <ThrowOnError extends boolean = false>(options: Options<CreateResidenceCategoryData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CreateResidenceCategoryResponses, CreateResidenceCategoryErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/residence-categories',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Delete residence category
 * Deletes a residence category.
 */
export const deleteResidenceCategory = <ThrowOnError extends boolean = false>(options: Options<DeleteResidenceCategoryData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<DeleteResidenceCategoryResponses, DeleteResidenceCategoryErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/residence-categories/{residenceCategoryId}',
        ...options
    });
};

/**
 * Get residence category
 * Gets a specific residence category.
 */
export const getResidenceCategory = <ThrowOnError extends boolean = false>(options: Options<GetResidenceCategoryData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetResidenceCategoryResponses, GetResidenceCategoryErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/residence-categories/{residenceCategoryId}',
        ...options
    });
};

/**
 * Update residence category
 * Updates a residence category.
 */
export const updateResidenceCategory = <ThrowOnError extends boolean = false>(options: Options<UpdateResidenceCategoryData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<UpdateResidenceCategoryResponses, UpdateResidenceCategoryErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/residence-categories/{residenceCategoryId}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get residence types
 * Gets a list of residence types.
 */
export const getResidenceTypeList = <ThrowOnError extends boolean = false>(options: Options<GetResidenceTypeListData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetResidenceTypeListResponses, GetResidenceTypeListErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/residence-types',
        ...options
    });
};

/**
 * Create residence type
 * Creates a new residence type.
 */
export const createResidenceType = <ThrowOnError extends boolean = false>(options: Options<CreateResidenceTypeData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CreateResidenceTypeResponses, CreateResidenceTypeErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/residence-types',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Delete residence type
 * Deletes a residence type.
 */
export const deleteResidenceType = <ThrowOnError extends boolean = false>(options: Options<DeleteResidenceTypeData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<DeleteResidenceTypeResponses, DeleteResidenceTypeErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/residence-types/{residenceTypeId}',
        ...options
    });
};

/**
 * Get residence type
 * Gets a specific residence type.
 */
export const getResidenceType = <ThrowOnError extends boolean = false>(options: Options<GetResidenceTypeData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetResidenceTypeResponses, GetResidenceTypeErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/residence-types/{residenceTypeId}',
        ...options
    });
};

/**
 * Update residence type
 * Updates a residence type.
 */
export const updateResidenceType = <ThrowOnError extends boolean = false>(options: Options<UpdateResidenceTypeData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<UpdateResidenceTypeResponses, UpdateResidenceTypeErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/residence-types/{residenceTypeId}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get unpublished residence types without image
 * Gets a list of unpublished residence types that have no image.
 */
export const getUnpublishedResidenceTypeWithNoImageList = <ThrowOnError extends boolean = false>(options: Options<GetUnpublishedResidenceTypeWithNoImageListData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetUnpublishedResidenceTypeWithNoImageListResponses, GetUnpublishedResidenceTypeWithNoImageListErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/residence-types/unpublished-no-image',
        ...options
    });
};

/**
 * Get image for residence type
 * Gets the image for a specific residence type.
 */
export const getResidenceTypeImage = <ThrowOnError extends boolean = false>(options: Options<GetResidenceTypeImageData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetResidenceTypeImageResponses, GetResidenceTypeImageErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/residence-types/{residenceTypeId}/image',
        ...options
    });
};

/**
 * Upload image for residence type
 * Uploads an image for a specific residence type.
 */
export const uploadImageForResidenceType = <ThrowOnError extends boolean = false>(options: Options<UploadImageForResidenceTypeData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<UploadImageForResidenceTypeResponses, UploadImageForResidenceTypeErrors, ThrowOnError>({
        ...formDataBodySerializer,
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/residence-types/{residenceTypeId}/image',
        ...options,
        headers: {
            'Content-Type': null,
            ...options.headers
        }
    });
};

/**
 * Assign customer to residence type
 * Assigns a customer to a specific residence type.
 */
export const getAssignedCustomerListFromResidenceType = <ThrowOnError extends boolean = false>(options: Options<GetAssignedCustomerListFromResidenceTypeData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetAssignedCustomerListFromResidenceTypeResponses, GetAssignedCustomerListFromResidenceTypeErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/residence-types/{residenceTypeId}/assigned-customers',
        ...options
    });
};

/**
 * Assign customer to residence type
 * Assigns a customer to a specific residence type.
 */
export const assignCustomerToResidenceType = <ThrowOnError extends boolean = false>(options: Options<AssignCustomerToResidenceTypeData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<AssignCustomerToResidenceTypeResponses, AssignCustomerToResidenceTypeErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/residence-types/{residenceTypeId}/assigned-customers',
        ...options
    });
};

/**
 * Unassign customer from residence type
 * Unassigns a customer from a specific residence type.
 */
export const unassignCustomerFromResidenceType = <ThrowOnError extends boolean = false>(options: Options<UnassignCustomerFromResidenceTypeData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<UnassignCustomerFromResidenceTypeResponses, UnassignCustomerFromResidenceTypeErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/residence-types/{residenceTypeId}/assigned-customers/{customerId}',
        ...options
    });
};

/**
 * Publish residence type
 * Publishes a residence type.
 */
export const publishResidenceType = <ThrowOnError extends boolean = false>(options: Options<PublishResidenceTypeData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<PublishResidenceTypeResponses, PublishResidenceTypeErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/residence-types/{residenceTypeId}/publish',
        ...options
    });
};

/**
 * Unpublish residence type
 * Unpublishes a residence type.
 */
export const unpublishResidenceType = <ThrowOnError extends boolean = false>(options: Options<UnpublishResidenceTypeData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<UnpublishResidenceTypeResponses, UnpublishResidenceTypeErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/residence-types/{residenceTypeId}/unpublish',
        ...options
    });
};

/**
 * Archive residence type
 * Archives a residence type.
 */
export const archiveResidenceType = <ThrowOnError extends boolean = false>(options: Options<ArchiveResidenceTypeData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ArchiveResidenceTypeResponses, ArchiveResidenceTypeErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/residence-types/{residenceTypeId}/archive',
        ...options
    });
};

/**
 * Get roof types
 * Gets a list of roof types.
 */
export const getRoofTypeList = <ThrowOnError extends boolean = false>(options: Options<GetRoofTypeListData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetRoofTypeListResponses, GetRoofTypeListErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/roof-types',
        ...options
    });
};

/**
 * Create roof type
 * Creates a new roof type.
 */
export const createRoofType = <ThrowOnError extends boolean = false>(options: Options<CreateRoofTypeData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CreateRoofTypeResponses, CreateRoofTypeErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/roof-types',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Delete roof type
 * Deletes a roof type.
 */
export const deleteRoofType = <ThrowOnError extends boolean = false>(options: Options<DeleteRoofTypeData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<DeleteRoofTypeResponses, DeleteRoofTypeErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/roof-types/{roofTypeId}',
        ...options
    });
};

/**
 * Get roof type
 * Gets a specific roof type.
 */
export const getRoofType = <ThrowOnError extends boolean = false>(options: Options<GetRoofTypeData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetRoofTypeResponses, GetRoofTypeErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/roof-types/{roofTypeId}',
        ...options
    });
};

/**
 * Update roof type
 * Updates a roof type.
 */
export const updateRoofType = <ThrowOnError extends boolean = false>(options: Options<UpdateRoofTypeData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<UpdateRoofTypeResponses, UpdateRoofTypeErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/roof-types/{roofTypeId}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get scenario list
 * Retrieves a list of scenarios with optional filtering and pagination.
 */
export const getScenarioList = <ThrowOnError extends boolean = false>(options: Options<GetScenarioListData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetScenarioListResponses, GetScenarioListErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/scenarios',
        ...options
    });
};

/**
 * Get scenario
 * Retrieves a scenario.
 */
export const getScenario = <ThrowOnError extends boolean = false>(options: Options<GetScenarioData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetScenarioResponses, GetScenarioErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/scenarios/{scenarioId}',
        ...options
    });
};

/**
 * Publish scenario
 * Publishes a scenario.
 */
export const publishScenario = <ThrowOnError extends boolean = false>(options: Options<PublishScenarioData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<PublishScenarioResponses, PublishScenarioErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/scenarios/{scenarioId}/publish',
        ...options
    });
};

/**
 * Unpublish scenario
 * Unpublishes a scenario.
 */
export const unpublishScenario = <ThrowOnError extends boolean = false>(options: Options<UnpublishScenarioData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<UnpublishScenarioResponses, UnpublishScenarioErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/scenarios/{scenarioId}/unpublish',
        ...options
    });
};

/**
 * Get situation list
 * Retrieves a list of situations with optional filtering and pagination.
 */
export const getSituationList = <ThrowOnError extends boolean = false>(options: Options<GetSituationListData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetSituationListResponses, GetSituationListErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/situations',
        ...options
    });
};

/**
 * Get situation
 * Retrieves a situation.
 */
export const getSituation = <ThrowOnError extends boolean = false>(options: Options<GetSituationData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetSituationResponses, GetSituationErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/situations/{situationId}',
        ...options
    });
};

/**
 * Publish situation
 * Publishes a situation.
 */
export const publishSituation = <ThrowOnError extends boolean = false>(options: Options<PublishSituationData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<PublishSituationResponses, PublishSituationErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/situations/{situationId}/publish',
        ...options
    });
};

/**
 * Unpublish situation
 * Unpublishes a situation.
 */
export const unpublishSituation = <ThrowOnError extends boolean = false>(options: Options<UnpublishSituationData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<UnpublishSituationResponses, UnpublishSituationErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/situations/{situationId}/unpublish',
        ...options
    });
};